import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const containerUpdateAtom = createMutationAtomFactory(
  'trade.containerUpdate',
  (params: {
    id: string;
    containerNumber?: string | null;
    sealNumber?: string | null;
    facilityId?: string | null;
  }) => ({
    tradeContainerUpdate: {
      __args: {
        id: params.id,
        input: {
          containerNumber: params.containerNumber,
          sealNumber: params.sealNumber,
          facilityId: params.facilityId,
        },
      },
      id: true,
      status: true,
      containerNumber: true,
      sealNumber: true,
      bookingId: true,
      containerTypeId: true,
      facilityId: true,
    },
  }),
);

export const containerDeleteAtom = createMutationAtomFactory(
  'trade.containerDelete',
  (params: { id: string }) => ({
    tradeContainerDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
